import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/manual_winner`;

class ManualWinnerServices {
  async getSessionList(activeGame, date_filter) {
    try {
      const action =
        API_ROUTE +
        `/get-session-list?game=${activeGame}&date_filter=${date_filter}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getSessionList:", error);
      throw error;
    }
  }

  async getManualSessionList(filter) {
    try {
      const action =
        API_ROUTE +
        `/get-manual-session-list?${filter}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getManualSessionList:", error);
      throw error;
    }
  }

  async createManualWinner(payload) {
    try {
      const action = API_ROUTE + `/save-manual_winner-data`;
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in createManualWinner:", error);
      throw error;
    }
  }

  async updateManualWinner(payload) {
    try {
      const action = API_ROUTE + `/update-manual_winner-data`;
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in updateManualWinner:", error);
      throw error;
    }
  }
  async deleteManualWinnerSession(session_id) {
    try {
      const action = API_ROUTE + `/delete-manual_winner-data?session_id=${session_id}`;
      return await requestToken.del(action);
    } catch (error) {
      console.error("Error in deleteManualWinnerSession:", error);
      throw error;
    }
  }


}

export default ManualWinnerServices;
